module.exports = __webpack_public_path__ + "static/img/cmf-cropped.b8de43e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/373x100/cmf-cropped.png
// module id = 1245
// module chunks = 1